import { combineReducers, Reducer } from 'redux';

import { connectRouter } from 'connected-react-router';
import { History } from 'history';

import typedReducers from 'store/typedReducers';

const createRootReducer = (history: History): Reducer =>
    combineReducers({ ...typedReducers, router: connectRouter(history) });

export default createRootReducer;
